document.addEventListener("DOMContentLoaded", function () {
  const MQ = window.matchMedia("(min-width: 1024px)");
  const isDesktop = () => MQ.matches;

  const MENUS = [
    {
      key: "fabrics",
      navItemSelector:
        ".navmenu-id-hypalon\\®-orca-fabrics, .navmenu-id-hypalon-orca-fabrics",
      megaSelector: ".mega-menu--fabrics",
    },
    {
      key: "accessories",
      navItemSelector: ".navmenu-id-accessories, .navmenu-id-accessoires",
      megaSelector: ".mega-menu--accessories",
    },
  ];

  function getDetails(navItem) {
    return navItem ? navItem.querySelector('details[data-navmenu-details]') : null;
  }

  function getSummary(navItem) {
    return navItem ? navItem.querySelector("summary") : null;
  }

  function setupOneMenu(navItemSelector, megaSelector) {
    const navItem = document.querySelector(navItemSelector);
    if (!navItem) return;

    // Ensure mega menu exists inside this nav item
    const mega = navItem.querySelector(megaSelector);
    if (!mega) return;

    // mark custom mega => CSS can hide default submenu
    navItem.classList.add("has-custom-mega");

    let timer = null;
    let hoveringNav = false;
    let hoveringMega = false;

    const open = () => {
      if (!isDesktop()) return;
      clearTimeout(timer);
      hoveringNav = true;

      const details = getDetails(navItem);
      const summary = getSummary(navItem);

      // open details => CSS will display mega-menu
      if (details) details.open = true;
      if (summary) summary.setAttribute("aria-expanded", "true");

      navItem.classList.add("is-open");
    };

    const close = () => {
      if (!isDesktop()) return;

      const details = getDetails(navItem);
      const summary = getSummary(navItem);

      if (details) details.open = false;
      if (summary) summary.setAttribute("aria-expanded", "false");

      navItem.classList.remove("is-open");
    };

    const scheduleClose = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!isDesktop()) return;
        if (!hoveringNav && !hoveringMega) close();
      }, 180);
    };

    // Hover nav item
    navItem.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;
      hoveringNav = true;
      open();
    });

    navItem.addEventListener("mouseleave", () => {
      hoveringNav = false;
      scheduleClose();
    });

    // Hover mega menu
    mega.addEventListener("mouseenter", () => {
      if (!isDesktop()) return;
      hoveringMega = true;
      clearTimeout(timer);
      open();
    });

    mega.addEventListener("mouseleave", () => {
      hoveringMega = false;
      scheduleClose();
    });

    // Desktop: prevent default summary toggle/click navigation (hover controls)
    const summary = getSummary(navItem);
    if (summary) {
      summary.addEventListener(
        "click",
        (e) => {
          if (!isDesktop()) return;
          e.preventDefault();
          e.stopPropagation();
          open();
        },
        { capture: true }
      );
    }

    // Reset when going mobile
    const reset = () => {
      hoveringNav = false;
      hoveringMega = false;
      clearTimeout(timer);
      navItem.classList.remove("is-open");
      const details = getDetails(navItem);
      if (details) details.open = false;
      const summary = getSummary(navItem);
      if (summary) summary.setAttribute("aria-expanded", "false");
    };

    window.addEventListener("resize", () => {
      if (!isDesktop()) reset();
    });

    // Init state
    if (!isDesktop()) reset();
  }

  function initMenus() {
    MENUS.forEach((m) => setupOneMenu(m.navItemSelector, m.megaSelector));
  }

  // Shopify can re-render header sections
  document.addEventListener("shopify:section:load", initMenus);
  initMenus();

  // -----------------------------------------
  // ACCESSORIES SIDEBAR: SWITCH PANEL ON HOVER
  // -----------------------------------------
  document.addEventListener("mouseover", function (e) {
    if (!isDesktop()) return;

    const btn = e.target.closest(".mega-menu__sidebar-item");
    if (!btn) return;

    const menuRoot = btn.closest(".mega-menu--accessories");
    if (!menuRoot) return;

    const sidebarItems = menuRoot.querySelectorAll(".mega-menu__sidebar-item");
    const panels = menuRoot.querySelectorAll(".mega-menu__panel");
    const handle = btn.dataset.accHandle;

    sidebarItems.forEach((b) => b.classList.toggle("is-active", b === btn));
    panels.forEach((panel) =>
      panel.classList.toggle("is-active", panel.dataset.accPanel === handle)
    );
  });
});
